import { CustomEventWithDetail, CustomEventWithoutDetail } from 'rune-ts';

export class DeleteDateEvent extends CustomEventWithoutDetail {}

export class selectCheckBoxEvent extends CustomEventWithDetail<{ name: string; checkbox_ids: number[] }> {}
